/**
 * @file 求人票の候補追加
 */
'use strict'

/**
 * @classname ShowJobInformation
 */
export default class ShowJobInformation {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	 constructor($e, controller) {
		console.log('ShowJobInformation.constructor')
		this._$e = $e
		this._controller = controller
		this.$targetCell = this._$e.closest('tr').find('.job-information-cell')
		this.memoText = this._$e.data('memo')
		this.jobInformationData = this.$targetCell.data('job-information')
		this.jobInformationCellText = this.$targetCell.text()
		this.modalBody = $('#modal-job-information').find('.modal-body')
		this._$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof ShowJobInformation
	 * @return {undefined}
	 */
	onClick() {
		console.log(`ShowJobInformation.onClick`, 'jobInformationData', this.jobInformationData, 'jobInformationCellText', this.jobInformationCellText)
		this.modalBody.empty()
		if (this.memoText) {
			this.modalBody.append(this.createMemoElement(this.memoText))
		}
		this.appendJobInformationHTML()
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof ShowJobInformation
	 * @return {undefined}
	 */
	appendJobInformationHTML() {
		console.log(
			`ShowJobInformation.appendJobInformationHTML`,
			'jobInformationData',
			this.jobInformationData,
			'jobInformationCellText',
			this.jobInformationCellText,
		)
		// data属性に ID|:|時給|:|期間 を[]で括って、, (カンマ)区切りで設定するようにしている
		// ex) [123|:|1,200 ~ 1,300円|:|即日〜３ヶ月（延長可）],[124|:|1,200 ~ 1,300円|:|即日〜３ヶ月（延長可）],...

		// 案件ごとの区切り文字
		const splitCommaStr = '],['
		// 案件内容の区切り文字
		const splitColonStr = '|:|'

		// 最初と最後の文字を削除する
		// コンストラクタで定義しないのは、もし、エラーになった時画面が表示されなくなるのを防ぐため
		const jobInformation = this.jobInformationData?.slice(1)?.slice(0, -1)
		const cellText = this.jobInformationCellText?.slice(1)?.slice(0, -1)

		const cellTextArr = cellText.split(splitCommaStr)
		const jobInformationArr = jobInformation.split(splitCommaStr)
		console.log(jobInformationArr, 'jobInformationArr', cellTextArr, 'cellTextArr')
		let $copyLinks = []
		// エラー回避のためif分
		if (cellTextArr.length <= jobInformationArr.length) {
			cellTextArr.forEach((el, index) => {
				const jobInformationEl = jobInformationArr[index]
				console.log(jobInformationEl, index)
				const HTML = this.createElement({
					title: el,
					id: jobInformationEl.split(splitColonStr)[0],
					salary: jobInformationEl.split(splitColonStr)[1],
					during: jobInformationEl.split(splitColonStr)[2],
					preview: jobInformationEl.split(splitColonStr)[3],
					index: index,
				})
				console.log(HTML)
				this.modalBody.append(HTML)
				const $copyLink = $(HTML).find('.btn-copy-link')
				this.activate($copyLink.attr('id'));
			})
		}
	}

	/**
	 * 職種カードを作成する
	 *
	 * @memberof ShowJobInformation
	 * @return {undefined}
	 */
	createElement({ title, id, salary, during, preview , index}) {
		console.log(`ShowJobInformation.createElement`)
		// tailwindクラスで書くとコンパイルされない可能性があるため、style直がきしている
		return `<div>
		<p class="font-bold text" style="margin-left:8px;font-size:14px;">${title}</p>
		<div class="card" style="margin-top:12px;">
			<div class="card-body">
				<div class="flex justify-center items-center">
					<p class="text" style="width:100px;font-size:14px;text-align:right;">仕事番号</p>
					<p class="text" style="width:500px;font-size:14px;margin-left:20px;">${id}</p>
				</div>
				<div class="flex justify-center items-center" style="margin-top:12px;">
					<p class="text" style="width:100px;font-size:14px;text-align:right;">時給</p>
					<p class="text" style="width:500px;font-size:14px;margin-left:20px;">${salary}</p>
				</div>
				<div class="flex justify-center items-center" style="margin-top:12px;">
					<p class="text" style="width:100px;font-size:14px;text-align:right;">期間</p>
					<p class="text" style="width:500px;font-size:14px;margin-left:20px;">${during}</p>
				</div>
				<div class="flex justify-center items-center mt-12">
					<p class="text" style="width:100px;font-size:14px;text-align:right;">プレビュー</p>
					<a class="anchor anchor-copy-link" style="width:500px;font-size:14px;margin-left:20px;" href="${preview}" target="_blank">${preview}</a>
					<div style="width:100px"><button class="btn btn-primary-white btn-copy-link" id='copy-link-${index}' type="button" data-target=".anchor-copy-link">コピー</button></div>
					<div class="success-msg">クリップボードにコピーしました</div>
				</div>
			</div>
		</div>
	</div>`
	}
	/**
	 * メモ欄を作成する
	 *
	 * @memberof ShowJobInformation
	 * @return {undefined}
	 */
	createMemoElement(text) {
		console.log(`ShowJobInformation.createMemoElement`)
		// tailwindクラスで書くとコンパイルされない可能性があるため、style直がきしている
		return `<div class="card" style="margin-top:12px;">
		<div class="card-body">
			<p class="text" style="max-height:200px;overflow-y:auto;font-size:14px;white-space:pre-line;">${text}</p>
		</div>
	</div>`
	}

	/**
	 * 履歴書エリアアクティベート
	 *
	 * @memberof AddResumeArea
	 * @return {undefined}
	 */
	 activate(btnId) {
		console.log(`ShowJobInformation.activate`)

		const $copyBtn = this.modalBody.find(`#${btnId}`);
		const $msg = $copyBtn.parent('div').siblings('.success-msg');
		const target = $copyBtn.attr('data-target')
		const $target = $copyBtn.closest('.card-body').find(target);

		$copyBtn.on('click', () => {
			console.log('CopyLink.onClick')
			const copyLink = $target.text()

			if(navigator.clipboard == undefined) {
				window.clipboardData.setData('Text', copyLink);
			} else {
				navigator.clipboard.writeText(copyLink);
			}
			$msg.fadeIn("slow", function () {
				$(this).delay(2000).fadeOut("slow");
			});
		});
	};
}